import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, unref as _unref, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createTextVNode as _createTextVNode, withCtx as _withCtx, resolveDynamicComponent as _resolveDynamicComponent, mergeProps as _mergeProps, createBlock as _createBlock, KeepAlive as _KeepAlive } from "vue"

const _hoisted_1 = { class: "staff-page text-changes-page" }
const _hoisted_2 = { class: "page-heading" }
const _hoisted_3 = { class: "page-eyebrow" }
const _hoisted_4 = {
  key: 0,
  class: "ui-empty"
}
const _hoisted_5 = { class: "space-y-3" }
const _hoisted_6 = { role: "button" }
const _hoisted_7 = { class: "file-changes" }
const _hoisted_8 = { role: "button" }
const _hoisted_9 = { class: "file-change-content" }
const _hoisted_10 = {
  class: "text-file-content",
  tabindex: "0",
  "aria-label": "Содержимое файла"
}
const _hoisted_11 = { class: "xml" }
const _hoisted_12 = {
  key: 1,
  class: "ui-empty"
}

import { Spinner } from '@/components/ui/spinner';
import { Badge } from '@/components/ui/badge';
import { Tabs, TabsList, TabsTrigger, TabsContent } from '@/components/ui/tabs';
import { FileCode2 } from '@lucide/vue';

import { ref, onMounted, getCurrentInstance } from 'vue';
import axios from 'axios';
import { useRoute } from 'vue-router';
import CodeDiffWrapper from '../components/CodeDiffWrapper.vue';

interface ChangeComponentWrapper {
  isLoading: boolean;
  dateUpdated: any;
  size: number;
  new: string;
  prev: string;
}


export default /*@__PURE__*/_defineComponent({
  __name: 'TextInfoChanges',
  setup(__props) {

const route = useRoute();
const instance = getCurrentInstance();

const groupedChanges = ref<
  {
    name: string;
    changes: ChangeComponentWrapper[];
  }[]
>([]);

const product = ref<string | any>(null);
const isLoaded = ref(false);
const diffComponent = CodeDiffWrapper;
const sometab = ref('content');

function formatDateTime(dateTime: string): string {
  return (
    instance?.appContext.config.globalProperties.$filters.dateTimeToDateWithTimeString(dateTime) ||
    ''
  );
}

async function initTextChanges() {
  product.value = route.params.product;
  const products = (await axios.get('/api/products/')).data as PagedList<Product>;
  const productId = products.results.find((p) => p.name == route.params.product)?.id;
  if (productId == null) {
    isLoaded.value = true;
    return;
  }

  const textInfoChanges = (
    (await axios.get('/api/properties/' + route.params.propertyId + '/text-infos/'))
      .data as TextInfoChange[]
  ).filter((t) => t.product == productId);

  const grouped = textInfoChanges.reduce((g: any, change: TextInfoChange) => {
    g[change.name] = g[change.name] || [];
    g[change.name].push(change);
    return g;
  }, {});

  for (const i in grouped) {
    const sorted = (grouped[i] as TextInfoChange[]).sort((x, y) =>
      x.updated_at > y.updated_at ? 1 : -1
    );

    const changes = [] as ChangeComponentWrapper[];

    for (let j = 0; j < sorted.length; j++) {
      const newTextChange = {
        isLoading: false,
        dateUpdated: sorted[j].updated_at,
        size: sorted[j].content.length,
        new: sorted[j].content,
        prev: j == 0 ? '' : sorted[j - 1].content,
      };
      changes.push(newTextChange);
    }

    const item = {
      name: i,
      changes: changes.sort((x, y) => (x.dateUpdated < y.dateUpdated ? 1 : -1)),
    };

    groupedChanges.value.push(item);
  }

  isLoaded.value = true;
}

onMounted(async () => {
  await initTextChanges();
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("main", _hoisted_1, [
    _createElementVNode("header", _hoisted_2, [
      _createElementVNode("div", null, [
        _createElementVNode("div", _hoisted_3, _toDisplayString(product.value), 1),
        _cache[1] || (_cache[1] = _createElementVNode("h1", null, "Изменения параметров", -1))
      ])
    ]),
    (!isLoaded.value)
      ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
          _createVNode(_unref(Spinner)),
          _cache[2] || (_cache[2] = _createElementVNode("span", null, "Загрузка изменений…", -1))
        ]))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_5, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(groupedChanges.value, (groupChange) => {
        return (_openBlock(), _createElementBlock("details", {
          key: groupChange.name,
          class: "file-group ui-panel"
        }, [
          _createElementVNode("summary", _hoisted_6, [
            _createVNode(_unref(FileCode2), { size: 17 }),
            _createElementVNode("span", null, _toDisplayString(groupChange.name), 1),
            _createVNode(_unref(Badge), { variant: "outline" }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(groupChange.changes.length), 1)
              ]),
              _: 2
            }, 1024)
          ]),
          _createElementVNode("div", _hoisted_7, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(groupChange.changes, (change) => {
              return (_openBlock(), _createElementBlock("details", {
                key: change.dateUpdated,
                class: "file-change"
              }, [
                _createElementVNode("summary", _hoisted_8, [
                  _createElementVNode("span", null, _toDisplayString(formatDateTime(change.dateUpdated)) + " (" + _toDisplayString(change.new.length) + " symbols) ", 1)
                ]),
                _createElementVNode("div", _hoisted_9, [
                  _createVNode(_unref(Tabs), {
                    modelValue: sometab.value,
                    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((sometab).value = $event))
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_unref(TabsList), null, {
                        default: _withCtx(() => [
                          _createVNode(_unref(TabsTrigger), { value: "content" }, {
                            default: _withCtx(() => [...(_cache[3] || (_cache[3] = [
                              _createTextVNode("Текущее содержимое", -1)
                            ]))]),
                            _: 1
                          }),
                          _createVNode(_unref(TabsTrigger), { value: "diff" }, {
                            default: _withCtx(() => [...(_cache[4] || (_cache[4] = [
                              _createTextVNode("История изменений", -1)
                            ]))]),
                            _: 1
                          })
                        ]),
                        _: 1
                      }),
                      _createVNode(_unref(TabsContent), { value: "content" }, {
                        default: _withCtx(() => [
                          _createElementVNode("pre", _hoisted_10, [
                            _createElementVNode("code", _hoisted_11, _toDisplayString(change.new), 1)
                          ])
                        ]),
                        _: 2
                      }, 1024),
                      _createVNode(_unref(TabsContent), { value: "diff" }, {
                        default: _withCtx(() => [
                          (_openBlock(), _createBlock(_KeepAlive, null, [
                            (_openBlock(), _createBlock(_resolveDynamicComponent(_unref(diffComponent)), _mergeProps({ ref_for: true }, {
                        oldString: change.prev,
                        newString: change.new,
                        context: 10,
                      }), null, 16))
                          ], 1024))
                        ]),
                        _: 2
                      }, 1024)
                    ]),
                    _: 2
                  }, 1032, ["modelValue"])
                ])
              ]))
            }), 128))
          ])
        ]))
      }), 128))
    ]),
    (isLoaded.value && !groupedChanges.value.length)
      ? (_openBlock(), _createElementBlock("p", _hoisted_12, "Нет изменений параметров"))
      : _createCommentVNode("", true)
  ]))
}
}

})